import React from 'react'
import { Link } from 'react-router-dom'
// Components
import LinksMap from '../components/LinksMap'
import PageTransition from '../components/PageTransition'
// CSS
import '../assets/css/form.css'
import '../assets/css/login-signup.css'

export default function Login() {
  return (
    <div className='login_page'>
      <PageTransition />
      <LinksMap linksArr={[{name: 'Home', path:'/', active: false}, {name: 'Account', path: '/account', active: false}, {name: 'Login', path: '/login', active: true}]} pageName="Login" />

      <form className='login-form default'>
        <div className='form_header'>
          <p>Login to your account to buy products and explore the site.</p>
        </div>
        
        <div className='inputs'>
          <div className='input_container'>
            <label for='email'>Email</label>
            <input type='email' id='email' placeholder='Ex: example@example.com' />
          </div>

          <div className='input_container'>
            <label for='password'>Password</label>
            <input type='password' id='password' placeholder='Enter your password' />
          </div>
        </div>

        <div className='actions'>
          <button type='submit' className='submit_btn'>Login</button>
        </div>
        <div className='sl_link'>
          <span>Don't have an account?</span>
          <Link to='/signup'><button>Signup</button></Link>
        </div>
      </form>
    </div>
  )
}
